export default __webpack_public_path__ + "static/media/v.f90ef09d.mp3";